import { css, CSSObject } from 'styled-components';
import {
  Breakpoints,
  Media,
  MediaObject,
  MediaTagFunction,
} from './media.types';
import makeAliases from '../aliases/makeAliases';

export const noBreakpoint = '_';
export const defaultBreakpoints = makeAliases({
  lg: 1280,
  md: 768,
  sm: 576,
  xs: 575,
}) as Breakpoints;

const media: MediaObject = (Object.keys(defaultBreakpoints) as Media[]).reduce(
  (accumulator, label) => {
    const minMedia: MediaTagFunction = (strings, ...interpolations) => css`
      @media (min-width: ${defaultBreakpoints[label]}px) {
        ${css(strings as CSSObject | TemplateStringsArray, ...interpolations)}
      }
    `;

    const maxMedia: MediaTagFunction = (strings, ...interpolations) => css`
      @media (max-width: ${defaultBreakpoints[label] - 1}px) {
        ${css(strings as CSSObject | TemplateStringsArray, ...interpolations)}
      }
    `;

    accumulator[label] =
      label === 'xs' || label === 'smaller' ? maxMedia : minMedia;
    accumulator.max[label] = maxMedia;
    accumulator.min[label] = minMedia;

    return accumulator;
  },
  { min: {}, max: {} } as MediaObject,
);

export default media;
